<template> 
  <div>
    <aside id="slider" class="main-sidebar">
      <div  class="logo">
        <img src="/static/img/icons/ic_dinet_logo.png" class="logo-icon" />
      </div>
      <!-- sidebar: style can be found in sidebar.less -->
      <section class="sidebar">
        <!-- sidebar menu: : style can be found in sidebar.less -->
        <ul data-widget="tree" class="sidebar-menu">
          <va-slide-orange-item
            v-for="(item,index) in slideMenuItems"
            :data="item"
            :key="index"
            :type="item.type"
            :isHeader="item.isHeader"
            :icon="item.icon"
            :name="item.name"
            :badge="item.badge"
            :items="item.items"
            :router="item.router"
            :link="item.link"
          >
          </va-slide-orange-item>       
        </ul>
      </section>
      <div class="logout">
        <ul class="sidebar-menu">
          <li class="menu-logout">
            <router-link :to="{ name: 'Logout' }">
              <div><img class="logout-icon" /></div>
              <span class="side-parent">Cerrar Sesión</span>
            </router-link>         
          </li>
        </ul>      
        
      </div>    
      <!-- /.sidebar -->
    </aside>
    <div class="close-slider">
      <img src="/static/img/svg/close.svg" class="ico-close" @click="closeSlider()">
    </div>
  </div>
</template>

<script>
import VASlideOrangeItem from './VASlideOrangeItem'
import { mapGetters } from 'vuex'

export default {
  name: 'va-slider-orange',
  computed: {
    ...mapGetters([
      'slideMenuItems'
    ])
  },
  created () {

  },
  methods: {
    closeSlider () {
      $('#slider').removeClass('div-view')
      $('#slider').removeClass('div-display')
      $('.close-slider').removeClass('div-display')
      $('.main-header').removeClass('div-none')
    }
  },
  components: {
    'va-slide-orange-item': VASlideOrangeItem
  }
}
</script>

<style>

  .close-slider
  {        
    position: absolute;
    background: rgb(0 0 0 / 50%);
    vertical-align: middle;
    border-radius: 8px; 
    z-index: 830;
    display: none;   
    width: 100%;
    height: 100%;
    padding-left: 50px;    
  }

  .ico-close
  {
    padding: 8px;
    filter: brightness(0) saturate(100%) invert(100%) sepia(6%) saturate(7492%) hue-rotate(273deg) brightness(109%) contrast(117%);    
  }

  .sidebar-mini.sidebar-collapse .main-sidebar{
    background-color: #FFFFFF !important;
    -webkit-transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
    z-index: 850;
    position: fixed;
  }

  .monitor-icon{    
    content: url("/static/img/svg/chart-line-solid.svg");   
    padding-left: 6px !important;    
    filter: brightness(0) saturate(100%) invert(10%) sepia(81%) saturate(4087%) hue-rotate(210deg) brightness(106%) contrast(117%);
    opacity:0.8;
  }

  .monitor-icon{    
    content: url("/static/img/svg/chart-line-solid.svg");   
    padding-left: 6px !important;    
    filter: brightness(0) saturate(100%) invert(10%) sepia(81%) saturate(4087%) hue-rotate(210deg) brightness(106%) contrast(117%);
    opacity:0.8;
  }  

  .cargar-icon{
    content: url("/static/img/svg/cloud-upload-alt-solid.svg");    
    padding-left: 6px !important;
    filter: brightness(0) saturate(100%) invert(10%) sepia(81%) saturate(4087%) hue-rotate(210deg) brightness(106%) contrast(117%);
    opacity:0.8;
  }


/*   .citas-r-icon::before{
    content: url("/static/img/icons/ic_dinet_logo.png");
  }

  .citas-d-icon{
    content: url("/static/img/icons/exclamation-circle-solid.png");
  }

  .invetario-s-icon{
    content: url("/static/img/icons/ic_dinet_logo.png");
  } */

  .logo{
    display: flex;
    justify-content: center;    
    margin-left: -2px !important;
    padding-top: 20px;
    padding-bottom: 30px;
  }

  .logo-icon{
    width : 35px;
    border-radius: 4px;
  }
  
  .seguimiento-icon{
    content: url("/static/img/svg/search-solid.svg");
    filter: brightness(0) saturate(100%) invert(10%) sepia(81%) saturate(4087%) hue-rotate(210deg) brightness(106%) contrast(117%);   
    padding-left: 6px;
    opacity:0.8;
    width: 30px !important;
  }

  .ecommerce-icon{
    content: url("/static/img/svg/ecommerce.svg");
    filter: brightness(0) saturate(100%) invert(10%) sepia(81%) saturate(4087%) hue-rotate(210deg) brightness(106%) contrast(117%);   
    padding-left: 6px;
    opacity:0.8;
  }  

  .reglas-icon{
    content: url("/static/img/svg/exclamation-circle-solid.svg");
    filter: brightness(0) saturate(100%) invert(10%) sepia(81%) saturate(4087%) hue-rotate(210deg) brightness(106%) contrast(117%); 
    padding-left: 6px;
    opacity:0.8;
  }
  
  .productos-icon{
    content: url("/static/img/svg/P_icon-01.svg");
    filter: brightness(0) saturate(100%) invert(10%) sepia(81%) saturate(4087%) hue-rotate(210deg) brightness(106%) contrast(117%); 
    padding-left: 6px;
    opacity:0.8;
  }

  .avance-icon{
    content: url("/static/img/svg/check-square-solid.svg");
    filter: brightness(0) saturate(100%) invert(10%) sepia(81%) saturate(4087%) hue-rotate(210deg) brightness(106%) contrast(117%); 
    padding-left: 6px;
    opacity:0.8;
    width: 30px !important;
  }
  
  .inventario-e-icon{
    content: url("/static/img/svg/cube-solid.svg");
    filter: brightness(0) saturate(100%) invert(10%) sepia(81%) saturate(4087%) hue-rotate(210deg) brightness(106%) contrast(117%); 
    padding-left: 6px;
    opacity:0.8;
  }

  .servicio-icon{
    content: url("/static/img/svg/map-marker-alt-solid.svg");
    filter: brightness(0) saturate(100%) invert(10%) sepia(81%) saturate(4087%) hue-rotate(210deg) brightness(106%) contrast(117%); 
    padding-left: 6px;
    opacity:0.8;
  }

  .logout-icon
  {    
    content: url("/static/img/svg/logout.svg");   
    filter: brightness(0) saturate(100%) invert(10%) sepia(81%) saturate(4087%) hue-rotate(210deg) brightness(106%) contrast(117%); 
    padding-left: 6px !important;
    opacity:0.8;
    width: 32px;
  }  
 
  .logout{
    position: absolute;
    bottom: 0;    
  }
  /*
  .sidebar-menu>li.menu-logout>a>div>img:hover
  {
    filter: brightness(0) saturate(100%) invert(19%) sepia(73%) saturate(6805%) hue-rotate(356deg) brightness(95%) contrast(114%) !important; 
  }
  */

</style>



// WEBPACK FOOTER //
// SliderOrange.vue?5c08910b